import { HtmlParser } from '@calendly/html-parser'
import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { GridItem } from '@calendly/ui/components/grid'
import { BodyText } from '@calendly/ui/components/typography'
import PropTypes from 'prop-types'

import { CardInput } from './input'
import {
  CardLoader,
  Row,
  RowGrid,
  StepCounter,
  StyledErrorMessage,
  VerifyEnableInformation,
  VerticalCenterGrid,
} from './shared_styles'


export const VerificationTxt = ({
  domain,
  onVerifyClick,
  verifyLoading,
  error,
  canAttemptVerifyByTimeframe,
  canAttemptVerifyByState
}) => {
  const verificationCode = domain.verification_code
  const verifyButtonEnabled = canAttemptVerifyByState && canAttemptVerifyByTimeframe && error == null

  if (verifyLoading) {
    return <CardLoader />
  }

  return (
    <>
      <RowGrid>
        <GridItem size="1">
          <StepCounter>1</StepCounter>
        </GridItem>
        <GridItem size="11">
          {I18n.t('publisher.organization_settings.domain_control.cards.pending.first_step')}
        </GridItem>
      </RowGrid>
      <RowGrid>
        <GridItem size="1">
          <StepCounter>2</StepCounter>
        </GridItem>
        <GridItem size="11">
          <Row>
            <BodyText data-testid="pending_second_step">
              {
              HtmlParser(I18n.t('publisher.organization_settings.domain_control.cards.pending.second_step',
                {
                  domain: domain.domain,
                  verification_method: domain.verification_method.toUpperCase()
                }))
              }
            </BodyText>
          </Row>
          <CardInput
            label={I18n.t('publisher.organization_settings.domain_control.cards.pending.txt_verify_label')}
            value={verificationCode}
            inputName="txt_dns_text"
          />
        </GridItem>
      </RowGrid>
      <RowGrid>
        <GridItem size="1">
          <StepCounter>3</StepCounter>
        </GridItem>
        <GridItem size="11">
          <Row>
            <BodyText>
              {I18n.t('publisher.organization_settings.domain_control.cards.pending.verify_description')}
            </BodyText>
          </Row>
          <Row>
            <VerticalCenterGrid>
              <GridItem size="3">
                <Button size="small" onClick={onVerifyClick} disabled={!verifyButtonEnabled}>
                  {I18n.t('publisher.organization_settings.domain_control.cards.verify_domain_button')}
                </Button>
              </GridItem>
              <GridItem size="9">
                {!canAttemptVerifyByTimeframe && (
                <BodyText color="muted">
                  {I18n.t('publisher.organization_settings.domain_control.cards.verify_rate_limit')}
                </BodyText>
                )}
                {error && <StyledErrorMessage message={error} />}
              </GridItem>
            </VerticalCenterGrid>

          </Row>
          <Row>
            <VerifyEnableInformation />
          </Row>
        </GridItem>
      </RowGrid>
    </>
  )
}

VerificationTxt.propTypes = {
  canAttemptVerifyByTimeframe: PropTypes.bool.isRequired,
  canAttemptVerifyByState: PropTypes.bool.isRequired,
  domain: PropTypes.shape({
    domain: PropTypes.string.isRequired,
    enforced: PropTypes.bool,
    last_checked_at: PropTypes.string,
    state: PropTypes.string,
    uuid: PropTypes.string.isRequired,
    verification_method: PropTypes.string.isRequired,
    verification_code: PropTypes.string,
  }).isRequired,
  error: PropTypes.string,
  onVerifyClick: PropTypes.func.isRequired,
  verifyLoading: PropTypes.bool.isRequired,
}
